import { useMutation } from "react-query";
import { addJobs } from "../../../../actions/Utilities/JobConfig";

const useAddJobs = () => {
  return useMutation(addJobs);
};

export default useAddJobs;
